import React from "react";
import { useNavigate } from "react-router-dom";
import { RunForm } from "../components/RunForm";
import { useRacing } from "../context/RacingContext";
import { useAuth } from "../context/AuthContext";
import { emptyRun } from "../constants/options";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Lock } from "lucide-react";

export default function AddRun() {
  const { addRun } = useRacing();
  const { user } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (run) => {
    await addRun(run);
    toast.success("Run logged!");
    navigate("/history");
  };

  const locked = user?.trialLocked;

  return (
    <div className="mx-auto max-w-3xl">
      <h1 className="mb-1 font-head text-3xl font-black tracking-tighter">Log a Run</h1>
      <p className="mb-6 text-sm text-mt-mutedfg">Enter your run — fast, right from the lanes.</p>
      {locked ? (
        <div className="rounded-xl border border-mt-border bg-mt-card p-10 text-center shadow-sm" data-testid="add-run-locked">
          <Lock size={32} className="mx-auto text-mt-primary" />
          <h3 className="mt-3 font-head text-xl font-bold">Your free trial has ended</h3>
          <p className="mt-1 text-sm text-mt-mutedfg">Upgrade to keep logging runs and unlock everything.</p>
          <Button onClick={() => navigate("/upgrade")} data-testid="add-run-upgrade" className="mt-4 gap-2 bg-mt-primary text-white hover:bg-mt-primary/90">
            Upgrade — $24.95
          </Button>
        </div>
      ) : (
        <RunForm initial={emptyRun()} onSubmit={handleSubmit} submitLabel="Save Run" />
      )}
    </div>
  );
}
